import React, { useState } from 'react';
import { Col, Form, Row, Typography, Upload, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import UIHelper from 'helpers/UIHelper';
import FormHelper from 'helpers/FormHelper';

const FileSection = ({ form }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  const validateFile = (file) => {
    const allowedTypes = {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true,
      'application/vnd.ms-excel': true,
    };
    const isSheet = allowedTypes[file.type];
    return isSheet;
  };

  const beforeUpload = async (file) => {
    if (validateFile(file)) {
      setFileList([file]);
      return false;
    }
    setFileList([]);
    form.setFieldsValue('file', []);
    UIHelper.openNotificationWithIcon(
      'error',
      'Invalid type of file, please select xls/xlsx',
    );
    return false;
  };
  return (
    <>
      <Row gutter={24}>
        <Col span={6}>
          <Typography.Title level={3}>
            {t('Allegato', 'Attachment')}
          </Typography.Title>
        </Col>
        <Col span={9}>
          <Form.Item
            name='file'
            getValueFromEvent={FormHelper.normFile}
            // valuePropName='fileList'
            rules={[
              {
                required: true,
                message: t('Please upload a file', 'Please upload a file.'),
              },
            ]}
          >
            <Upload.Dragger
              name='file'
              multiple={false}
              beforeUpload={beforeUpload}
              fileList={fileList}
              onRemove={() => {
                setFileList([]);
                form.setFieldsValue({ file: [] });
              }}
              accept='.xls,.xlsx'
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
               {t('Click or drag file to this area to upload1')}
               'XLS', 'XLSX'
               {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item
              label={t('Formati accettati', 'Accepted formats') + ':'}
            >
              XLS, XLSX
            </Descriptions.Item>
            <Descriptions.Item
              label={t('Dimensione massima', 'Maximum size') + ':'}
            >
              20MB
            </Descriptions.Item>
            <Descriptions.Item>
              <a
                id='download-file'
                target='_blank'
                rel='noopener noreferrer'
                href={'https://dev.arcusnet.it/invoice_monthly.xlsx'}
              >
                {t('Scarica un file di esempio')}
              </a>
            </Descriptions.Item>
          </Descriptions>
          <p style={{ margin: '20px 0 20px 0' }}>
            Importante rispettare il Template Excel , non cambiare le
            intestazioni di colonna e compilare tutti i valori per ogni data di
            apertura del punto vendita . Non inserire date e  valori per i
            giorni di chiusura
          </p>
        </Col>
      </Row>
    </>
  );
};

export default React.memo(FileSection);
